import { render, staticRenderFns } from "./m_russia_business.vue?vue&type=template&id=eca3a662&scoped=true"
import script from "./m_russia_business.vue?vue&type=script&lang=js"
export * from "./m_russia_business.vue?vue&type=script&lang=js"
import style0 from "./m_russia_business.vue?vue&type=style&index=0&id=eca3a662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca3a662",
  null
  
)

export default component.exports